var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum } from '@snapaddy/backend-client-axios';
import { isDefined, OrderUserBy } from '@snapaddy/snapaddy-types/common';
import { Component } from 'angular-ts-decorators';
import { getPossibleArticleNumbers } from '../articleNumbers/get-possible-article-numbers';
import { isSupportAccessDeniedError } from '../shared/is-support-access-denied-error';
import { broadcastOrganizationSwitch } from '../shared/organization-switch';
import { isValidEmail } from '../shared/util/is-valid-email';
import { resetLoadingBtns, setLoadingBtn } from '../shared/util/loading-button-util';
import { ArticleNumber, CONCURRENT_ARTICLE_NUMBERS, DATA_AGENTS_ARTICLE_NUMBERS, DATA_ENRICHMENT, DEFAULT_DATA_AGENTS_CREDITS_BY_ARTICLE_NUMBER, SUBSCRIPTION_TYPES, UNLIMITED_LICENSES_ARTICLE_NUMBERS, } from './types';
/**
 * List of all feature flags that are managed via the UI in the organization settings.
 * (There could also be unmanaged feature flags that are not in this list and only be set via DB)
 */
const MANAGED_FEATURE_FLAGS = [
    IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.AZURE_OPT_OUT,
    IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.WHITE_LABEL_DIGITAL_BUSINESS_CARDS,
    IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.HAS_DASHBOARD_AGENT,
    IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.SKIP_CLAIMED_DOMAIN_VALIDATION_FOR_REPORTER_INVITES,
];
function arrayToObject(arr, possibleValues) {
    const lookUp = {};
    for (let i = 0; i < possibleValues.length; i++) {
        lookUp[possibleValues[i]] = arr.indexOf(possibleValues[i]) !== -1;
    }
    return lookUp;
}
function createNewOrgaFormViewModel() {
    return {
        companyName: '',
        email: '',
        emailUserExists: false,
        emailDomainClaimed: false,
        firstName: '',
        gender: '-1',
        has_azure_opt_out: false,
        has_custom_business_card_footer: false,
        has_dashboard_agent: false,
        skip_claimed_domain_validation_for_reporter_invites: false,
        lastName: '',
        locale: '',
        sendInvitation: true,
        skipHubspotContactCreation: true,
        valid: false,
    };
}
let OrganizationController = class OrganizationController {
    $location;
    $scope;
    $timeout;
    backendService;
    organizationService;
    userService;
    /** Sets Billwerk URL depending on current env (identified via URL only) */
    billwerkUrl = window.location.host === 'app.snapaddy.com' ? 'https://app.billwerk.com' : 'https://sandbox.billwerk.com';
    currentPage = 0;
    filter = '';
    filtered_orga_count = 0;
    isLoading = true;
    max_pages = 1;
    modalModel = createNewOrgaFormViewModel();
    newOrgaModalModel = createNewOrgaFormViewModel();
    openAgain = undefined;
    orgas = [];
    page_size = 25;
    showDeleted = false;
    // Feature flags that cannot be set in the UI
    // Either because we forgot to add them here or because we explicitly only want to set them via DB
    unmanagedFeatureFlags = [];
    unlimitedLicensesArticleNumbers = UNLIMITED_LICENSES_ARTICLE_NUMBERS;
    concurrentArticleNumbers = CONCURRENT_ARTICLE_NUMBERS;
    /** snapADDY GmbH legal entity id, injected from the view; used to derive the billwerk customer locale. */
    legalEntityIdGmbh = '';
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$location', '$scope', '$timeout', 'BackendService', 'OrganizationService', 'UserService'];
    constructor($location, $scope, $timeout, backendService, organizationService, userService) {
        this.$location = $location;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.backendService = backendService;
        this.organizationService = organizationService;
        this.userService = userService;
        $scope.init = (legalEntityIdGmbh) => {
            this.legalEntityIdGmbh = legalEntityIdGmbh;
        };
        this.setup().catch((e) => {
            console.error('Failed to setup organization controller', e);
        });
    }
    async changePage(pageOffset) {
        const toPage = this.currentPage + pageOffset;
        if (toPage >= 0 && toPage < this.max_pages) {
            this.currentPage = toPage;
            await this.updateOrgas(toPage);
        }
    }
    async openModal(orga) {
        const dataEnrichmentSupply = await this.backendService.getDataEnrichmentMaxSupply(orga.organization_id);
        // res is an array so we have to find the `maxRequests` of specific supplies via their name
        const companyDataSearchSupply = dataEnrichmentSupply.find((supply) => {
            return supply.resourceName === DATA_ENRICHMENT.COMPANY_DATA_SEARCH_RESOURCE_NAME;
        });
        const emailFinderSupply = dataEnrichmentSupply.find((supply) => {
            return supply.resourceName === DATA_ENRICHMENT.EMAIL_FINDER_RESOURCE_NAME;
        });
        this.modalModel.company_data_search_max_supply = companyDataSearchSupply ? companyDataSearchSupply.maxRequests : 0;
        this.modalModel.email_finder_max_supply = emailFinderSupply ? emailFinderSupply.maxRequests : 0;
        await this.updateOrgas();
        if (orga.deletion_notice && orga.deletion_notice.sent_at) {
            orga.deletion_notice.deletion_notice_until = orga.deletion_notice.deletion_notice_until
                ? new Date(orga.deletion_notice.deletion_notice_until)
                : null;
            orga.deletion_notice.sent_at = new Date(orga.deletion_notice.sent_at);
            // Make the html date picker not show seconds and milliseconds
            orga.deletion_notice.sent_at.setMilliseconds(0);
            orga.deletion_notice.sent_at.setSeconds(0);
        }
        // Organization information
        this.modalModel.orgaRef = {
            ...orga,
            // Will be updated before exiting this function:
            has_azure_opt_out: false,
            // Will be updated before exiting this function:
            has_custom_business_card_footer: false,
            has_dashboard_agent: false,
            skip_claimed_domain_validation_for_reporter_invites: false,
        };
        this.modalModel.organization_id = orga.organization_id;
        this.modalModel.organization_name = orga.name;
        this.modalModel.organization_note = orga.organization_note;
        this.modalModel.is_deleted = orga.is_deleted;
        this.modalModel.original_deletion_notice = orga.deletion_notice;
        this.modalModel.deletion_notice = structuredClone(orga.deletion_notice);
        this.modalModel.billwerk_customer_id = orga.billwerk_customer_id;
        this.modalModel.billwerk_legal_entity_id = orga.billwerk_legal_entity_id;
        this.modalModel.hubspot_company_id = orga.hubspot_company_id;
        this.modalModel.subscription_management_connected = !!this.modalModel.billwerk_customer_id;
        // Reset any potentially existing values from previously opened organization modals. If DataAgents module is active
        // we will fetch the correct info later.
        this.modalModel.data_agents_available_credits = undefined;
        this.modalModel.data_agents_spent_credits = undefined;
        this.modalModel.data_agents_spent_credits_initial = undefined;
        this.modalModel.data_agents_total_credits = undefined;
        this.modalModel.data_agents_total_credits_initial = undefined;
        this.modalModel.data_agents_consumption_period_end = undefined;
        this.modalModel.data_agents_consumption_period_start = undefined;
        this.modalModel.data_agents_current_active_workflows = undefined;
        this.modalModel.data_agents_max_active_workflows = undefined;
        this.modalModel.data_agents_max_active_workflows_initial = undefined;
        this.modalModel.data_agents_max_active_workflows_unlimited_initial = undefined;
        this.modalModel.data_agents_max_active_workflows_unlimited = undefined;
        // Claimed domains
        this.modalModel.domains =
            orga.intern_config && Array.isArray(orga.intern_config.domains) ? orga.intern_config.domains.join(',') : '';
        // Deactivated Permissions
        this.modalModel.permissions_deactivated = orga.permissions_deactivated || [];
        this.modalModel.permissions_deactivated_object = arrayToObject(orga.permissions_deactivated || [], [
            'ACCESS_VR_ANALYTICS',
            'ACCESS_VR_ANALYTICS_PERSDATA',
        ]);
        const activeArticleNumbers = orga.subscriptions?.map((s) => s.article_number) ?? [];
        const activeModulePrefixes = new Set();
        for (const subscription of orga.subscriptions ?? []) {
            for (const subscriptionType of subscription.organization_subscription_types ?? []) {
                for (const module of subscriptionType.subscription_type.modules ?? []) {
                    if (subscriptionType.modules_deactivated?.some((md) => md.module_id === module.module_id)) {
                        continue;
                    }
                    activeModulePrefixes.add(module.prefix);
                }
            }
        }
        this.modalModel.subscriptions = orga
            .subscriptions // Ensure same order
            .sort((a, b) => a.article_number.localeCompare(b.article_number))
            .map((s) => {
            const products = s
                .organization_subscription_types // preserve the order in case there is more than one organization subscription type (only VisitReport Terminal).
                .sort((a, b) => a.subscription_type.name.localeCompare(b.subscription_type.name))
                .map((product) => ({
                id: product.organization_subscription_type_id,
                product_names: product.subscription_type.modules.map((m) => m.name).join(', '),
                name: product.subscription_type.name,
                valid_until: new Date(product.valid_until),
                subscription_valid_until: s.valid_until ? new Date(s.valid_until) : undefined,
                max_users: product.max_users,
                subscription_max_users: s.max_users,
                used_user_licenses_count: product.used_user_licenses.length,
                pending_user_licenses: product.pending_user_licenses.map((ul) => ({
                    id: ul.user_license_id,
                    assigned_at: new Date(ul.assigned_at).toLocaleDateString(),
                    unassigned_at: new Date(ul.unassigned_at).toLocaleDateString(),
                    assigned_until: new Date(ul.assigned_until).toLocaleDateString(),
                    release: false,
                })),
                available_modules: product.subscription_type.modules.map((m) => {
                    return {
                        ...m,
                        checked: !product.modules_deactivated.some((md) => md.module_id === m.module_id),
                    };
                }),
            }));
            return {
                id: s.subscription_id,
                is_new: false,
                // Subscription
                app_store_contract_id: s.app_store_contract_id,
                play_store_contract_id: s.play_store_contract_id,
                billwerk_contract_id: s.billwerk_contract_id,
                persisted_billwerk_contract_id: s.billwerk_contract_id,
                article_number: s.article_number,
                original_article_number: s.article_number,
                article_number_selection: getPossibleArticleNumbers(activeArticleNumbers, activeModulePrefixes, s.article_number),
                // Only synchronize valid_until date when getting updates from external subscription management
                sync_valid_until_only: s.sync_valid_until_only,
                valid_from: s.valid_from ? new Date(s.valid_from) : undefined,
                // Meta
                name: SUBSCRIPTION_TYPES.get(s.article_number)?.nameShort ?? 'UN',
                label: s.label,
                // Credits (only relevant for free trials)
                credits: Math.max(s.grabs_left, 0),
                credits_limit: s.grab_limit,
                checkbox_selected: s.grab_limit === -1,
                show_credits: s.article_number === '9999',
                show_data_enrichment_supply: s.article_number === '1904',
                // Products within a subscription (e.g. LeadResearch). As represented by the snapaddy_subscription_type table in the DB
                products,
                active_module_prefixes: new Set(products.flatMap((p) => p.available_modules.filter((m) => m.checked).map((m) => m.prefix))),
            };
        });
        this.modalModel.subscriptions.push({
            is_new: true,
            app_store_contract_id: '',
            play_store_contract_id: '',
            billwerk_contract_id: '',
            persisted_billwerk_contract_id: '',
            article_number: '',
            article_number_selection: getPossibleArticleNumbers(activeArticleNumbers, activeModulePrefixes),
            sync_valid_until_only: false,
            credits: -1,
            checkbox_selected: true,
            show_credits: false,
            products: [],
            active_module_prefixes: new Set(),
            original_billwerk_contract_id: '',
            original_products: [],
        });
        if (activeModulePrefixes.has('DA ')) {
            const creditsInfo = await this.backendService.getDataAgentsCredits(orga.organization_id);
            const workflowInfo = await this.backendService.getActiveWorkflowLimit(orga.organization_id);
            this.modalModel.data_agents_current_active_workflows = workflowInfo.active;
            this.modalModel.data_agents_max_active_workflows_initial = workflowInfo.maxParallel;
            this.modalModel.data_agents_max_active_workflows = workflowInfo.maxParallel;
            this.modalModel.data_agents_max_active_workflows_unlimited = workflowInfo.maxParallel === null;
            this.modalModel.data_agents_max_active_workflows_unlimited_initial = workflowInfo.maxParallel === null;
            this.modalModel.data_agents_available_credits = creditsInfo.currentConsumptionPeriod?.availableCredits ?? 0;
            this.modalModel.data_agents_spent_credits_initial = creditsInfo.currentConsumptionPeriod?.spentCredits ?? 0;
            this.modalModel.data_agents_spent_credits = creditsInfo.currentConsumptionPeriod?.spentCredits ?? 0;
            this.modalModel.data_agents_total_credits_initial = creditsInfo.totalCreditsPerYear;
            this.modalModel.data_agents_total_credits = creditsInfo.totalCreditsPerYear;
            this.modalModel.data_agents_consumption_period_start = creditsInfo.currentConsumptionPeriod
                ? new Date(creditsInfo.currentConsumptionPeriod.startDate)
                : undefined;
            this.modalModel.data_agents_consumption_period_end = creditsInfo.currentConsumptionPeriod
                ? new Date(creditsInfo.currentConsumptionPeriod.endDate)
                : undefined;
        }
        this.modalModel.has_social_network_update_access = orga.has_social_network_update_access;
        this.modalModel.has_onboarding_access = orga.has_onboarding_access;
        /**
         * Get new feature flags from new consumption/feature-flag endpoint
         */
        const featureFlags = await this.backendService.getConsumptionFeatureFlags(this.modalModel.organization_id);
        this.unmanagedFeatureFlags = featureFlags.filter((featureFlag) => !MANAGED_FEATURE_FLAGS.includes(featureFlag));
        const hasAzureOptOut = featureFlags.includes(IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.AZURE_OPT_OUT);
        const hasWhiteLabel = featureFlags.includes(IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.WHITE_LABEL_DIGITAL_BUSINESS_CARDS);
        const hasDashboardAgent = featureFlags.includes(IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.HAS_DASHBOARD_AGENT);
        const skipClaimedDomainValidationForReporterInvites = featureFlags.includes(IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.SKIP_CLAIMED_DOMAIN_VALIDATION_FOR_REPORTER_INVITES);
        this.modalModel.has_custom_business_card_footer = hasWhiteLabel;
        this.modalModel.has_azure_opt_out = hasAzureOptOut;
        this.modalModel.has_dashboard_agent = hasDashboardAgent;
        this.modalModel.skip_claimed_domain_validation_for_reporter_invites = skipClaimedDomainValidationForReporterInvites;
        if (this.modalModel.orgaRef) {
            this.modalModel.orgaRef.has_custom_business_card_footer = hasWhiteLabel;
            this.modalModel.orgaRef.has_azure_opt_out = hasAzureOptOut;
            this.modalModel.orgaRef.has_dashboard_agent = hasDashboardAgent;
            this.modalModel.orgaRef.skip_claimed_domain_validation_for_reporter_invites =
                skipClaimedDomainValidationForReporterInvites;
        }
        this.validateOrganizationInput(this.modalModel);
        $('#orga_modal_new').modal();
    }
    async onModalClose(e) {
        setLoadingBtn(e);
        if (this.modalModel.deletion_notice &&
            this.modalModel.deletion_notice?.deletion_notice_until?.getTime() !==
                this.modalModel.original_deletion_notice?.deletion_notice_until?.getTime() &&
            !window.confirm('Are you sure you want to change the planned deletion date?')) {
            resetLoadingBtns();
            return;
        }
        if (this.modalModel.checkbox_selected || !this.modalModel.show_credits) {
            this.modalModel.credits = -1;
            this.modalModel.credit_limit = -1;
        }
        if (this.modalModel.subscriptions?.some((s) => s.article_number && s.products.length === 0)) {
            this.openAgain = this.modalModel.organization_id;
        }
        const hasDataEnrichment = this.modalModel.subscriptions.some((subscription) => subscription.article_number.startsWith(ArticleNumber.DATA_ENRICHMENT));
        if (hasDataEnrichment) {
            await this.backendService.updateDataEnrichmentMaxSupply(this.modalModel.organization_id, this.modalModel.company_data_search_max_supply, this.modalModel.email_finder_max_supply);
        }
        if (isDefined(this.modalModel.data_agents_total_credits_initial)) {
            if (isDefined(this.modalModel.data_agents_total_credits) &&
                this.modalModel.data_agents_total_credits !== this.modalModel.data_agents_total_credits_initial) {
                // Organization already has DataAgents credits and the value was changed, so update it.
                await this.backendService.updateDataAgentsCredits(this.modalModel.organization_id, this.modalModel.data_agents_total_credits);
            }
        }
        else {
            // Organization does not have credits right now, check if a new subscription was added and if it has a default
            // credit amount, in which case we need to add those now.
            const newSubscription = this.modalModel.subscriptions?.find((s) => s.is_new && s.article_number);
            if (newSubscription) {
                const defaultCreditsForNewSubscription = DEFAULT_DATA_AGENTS_CREDITS_BY_ARTICLE_NUMBER.get(newSubscription.article_number);
                if (isDefined(defaultCreditsForNewSubscription)) {
                    await this.backendService.updateDataAgentsCredits(this.modalModel.organization_id, defaultCreditsForNewSubscription);
                }
            }
        }
        if (isDefined(this.modalModel.data_agents_spent_credits_initial) &&
            isDefined(this.modalModel.data_agents_spent_credits) &&
            this.modalModel.data_agents_spent_credits !== this.modalModel.data_agents_spent_credits_initial) {
            // Spent credits were manually changed, so update them to the new value.
            await this.backendService.setSpentDataAgentsCredits(this.modalModel.organization_id, this.modalModel.data_agents_spent_credits);
        }
        if (isDefined(this.modalModel.data_agents_max_active_workflows_initial) &&
            isDefined(this.modalModel.data_agents_max_active_workflows) &&
            isDefined(this.modalModel.data_agents_max_active_workflows_unlimited_initial) &&
            isDefined(this.modalModel.data_agents_max_active_workflows_unlimited) &&
            (this.modalModel.data_agents_max_active_workflows !== this.modalModel.data_agents_max_active_workflows_initial ||
                this.modalModel.data_agents_max_active_workflows_unlimited !==
                    this.modalModel.data_agents_max_active_workflows_unlimited_initial)) {
            const daSubscription = this.modalModel.subscriptions?.find((sub) => sub.active_module_prefixes.has('DA '));
            const product = daSubscription?.products[0];
            if (product?.id) {
                if (this.modalModel.data_agents_max_active_workflows_unlimited) {
                    // we just ticked the 'unlimited' box
                    await this.backendService.setActiveWorkflowLimit(product.id, null);
                }
                else {
                    // we might have unticked the 'unlimited' box
                    const newValue = this.modalModel.data_agents_max_active_workflows;
                    if (newValue === null) {
                        // and didn't add a new value or we just deleted the old value,
                        await this.backendService.removeActiveWorkflowLimit(product.id);
                    }
                    else {
                        // or we set some new value
                        await this.backendService.setActiveWorkflowLimit(product.id, newValue);
                    }
                }
            }
        }
        if (!this.proceedWithExceededLicenseLimit(this.modalModel.subscriptions)) {
            resetLoadingBtns();
            return;
        }
        try {
            await this.organizationService.updateOrganization(this.modalModel);
            this.modalModel.releaseAllCheckbox = {};
            $('#orga_modal_new').modal('hide');
            await this.updateOrgas();
        }
        catch (e) {
            console.error('Cannot update organization. Error: ', e);
            window.alert(e.data?.message ?? 'Oops! Something went wrong!');
        }
        finally {
            resetLoadingBtns();
        }
        /**
         * Set new feature flags by calling the new consumption/feature-flag endpoint
         */
        const featureFlags = [...this.unmanagedFeatureFlags];
        if (this.modalModel.has_custom_business_card_footer) {
            featureFlags.push(IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.WHITE_LABEL_DIGITAL_BUSINESS_CARDS);
        }
        if (this.modalModel.has_azure_opt_out) {
            featureFlags.push(IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.AZURE_OPT_OUT);
        }
        if (this.modalModel.has_dashboard_agent) {
            featureFlags.push(IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.HAS_DASHBOARD_AGENT);
        }
        if (this.modalModel.skip_claimed_domain_validation_for_reporter_invites) {
            featureFlags.push(IGetOrganizationFeatureFlagsResponseDtoFeatureFlagsEnum.SKIP_CLAIMED_DOMAIN_VALIDATION_FOR_REPORTER_INVITES);
        }
        const renderCards = this.modalModel.has_custom_business_card_footer !== this.modalModel.orgaRef?.has_custom_business_card_footer;
        await this.backendService.setConsumptionFeatureFlags(this.modalModel.organization_id, featureFlags, renderCards);
    }
    async createBillwerkCustomer(e) {
        setLoadingBtn(e);
        if (!this.modalModel.billwerk_legal_entity_id) {
            window.alert('Please select the legal entity first!');
            resetLoadingBtns();
            return;
        }
        // First get the first admin user we find to add their data to the billwerk contact
        // This is only a convenience thing so you don't have to fill in the data by hand
        let user;
        try {
            // Let's hope to just find an admin within the first 100 users. Yeah this is a bit hacky but the method is used
            // when creating new organizations and not when already hundreds of users are invited. We don't have an appropriate
            // endpoint for this purpose atm so let's just use this "hack" here since this is only for internal usage anyways
            // and it'll work fine even without a user.
            const searchResult = await this.userService.getUsers(0, 100, `orga:${this.modalModel.organization_id}`, OrderUserBy.USER_NAME_ASC);
            user = searchResult.users.find((u) => u.is_admin);
            if (!user) {
                throw new Error('No admin user found');
            }
        }
        catch (error) {
            // Actually we don't need the user information here. So let's simply continue
            console.error('Cannot get admin user for Frisbii customer creation.', error);
            window.alert('Did not find a user for creating the Frisbii customer. Customer details must be filled out manually');
        }
        try {
            await this.backendService.createBillwerkCustomerForOrganization(this.modalModel.organization_id, this.modalModel.organization_name, this.modalModel.billwerk_legal_entity_id, this.legalEntityIdGmbh, user);
            this.openAgain = this.modalModel.organization_id;
            $('#orga_modal_new').modal('hide');
            await this.updateOrgas();
        }
        catch (error) {
            console.error('Cannot create Frisbii customer', error);
            window.alert('Cannot create customer in Frisbii!');
        }
        finally {
            resetLoadingBtns();
        }
    }
    onChangeArticleNumber(modalModel, subscription) {
        if (subscription.article_number) {
            subscription.checkbox_selected = subscription.article_number !== '9999';
            subscription.show_credits = !subscription.checkbox_selected;
            if (subscription.article_number === subscription.original_article_number && subscription.products.length === 0) {
                subscription.products = subscription.original_products;
                subscription.billwerk_contract_id = subscription.original_billwerk_contract_id;
            }
            else if (subscription.article_number !== subscription.original_article_number &&
                subscription.products.length > 0) {
                subscription.original_products = subscription.products;
                subscription.products = [];
                subscription.original_billwerk_contract_id = subscription.billwerk_contract_id;
                subscription.billwerk_contract_id = '';
            }
        }
        else {
            subscription.checkbox_selected = true;
            subscription.show_credits = false;
        }
        const dataAgentsArticleNumbersForComparison = DATA_AGENTS_ARTICLE_NUMBERS;
        if (dataAgentsArticleNumbersForComparison.has(subscription.article_number)) {
            // Some subscriptions is being changed to DataAgents, set the supply to that subscriptions default.
            const newDefaultCredits = DEFAULT_DATA_AGENTS_CREDITS_BY_ARTICLE_NUMBER.get(subscription.article_number);
            if (isDefined(newDefaultCredits)) {
                modalModel.data_agents_total_credits = newDefaultCredits;
            }
        }
        this.validateOrganizationInput(modalModel);
    }
    validateOrganizationInput(modalModel) {
        const invalidInfo = [];
        modalModel.valid = true;
        if (modalModel.deletion_notice) {
            if (this.deletionNoticePeriodIsShortened()) {
                modalModel.valid = false;
                invalidInfo.push('- The planned deletion date cannot be made sooner than the original planned deletion date.');
            }
            if (this.deletionNoticePeriodIsRemoved()) {
                modalModel.valid = false;
                invalidInfo.push('- The planned deletion date cannot be cleared.');
            }
        }
        if (modalModel.subscriptions.filter((s) => s.products.some((p) => p.available_modules.some((m) => m.prefix === 'VRT' && m.checked))).length > 1) {
            modalModel.valid = false;
            invalidInfo.push('- In total, multiple checked <b>VRT</b> under <i>Products and features</i> is not allowed');
        }
        const subscriptionsWithDataAgents = modalModel.subscriptions.filter((s) => s.products.some((p) => p.available_modules.some((m) => m.prefix === 'DA ' && m.checked)));
        if (subscriptionsWithDataAgents.length > 1) {
            modalModel.valid = false;
            invalidInfo.push('- In total, multiple checked <b>DA</b> under <i>Products and features</i> is not allowed');
        }
        if (modalModel.billwerk_customer_id) {
            this.organizationService
                .getOrganizations(0, 10, 'customer-id:' + modalModel.billwerk_customer_id, false, true, true)
                .then((result) => {
                const sameCustomerOrgas = result.orgas.filter((orga) => orga.organization_id !== modalModel.organization_id);
                if (sameCustomerOrgas.length > 0) {
                    modalModel.valid = false;
                    invalidInfo.push("- <i>Customer Id</i> '" +
                        modalModel.billwerk_customer_id +
                        "' is already in use by " +
                        sameCustomerOrgas.map((orga) => `(Id: ${orga.organization_id})`).join(', '));
                }
            });
        }
        if (((modalModel.billwerk_legal_entity_id && !modalModel.billwerk_customer_id) ||
            (!modalModel.billwerk_legal_entity_id && modalModel.billwerk_customer_id)) &&
            modalModel.subscription_management_connected) {
            modalModel.valid = false;
            invalidInfo.push('- <i>Frisbii Legal Entity</i> and <i>Hubspot Company Id</i> must be set together');
        }
        modalModel.invalidInfo = invalidInfo.length > 0 ? invalidInfo.join('<br>') : '';
    }
    async deleteOrganization(model) {
        const orgaId = model.organization_id;
        if (!orgaId) {
            return;
        }
        if (!window.confirm('Are you sure you really want to delete the organization?')) {
            return;
        }
        await this.organizationService.deleteOrganization(orgaId);
        $('#orga_modal_new').modal('hide');
        await this.updateOrgas();
    }
    async restoreOrganization(model) {
        const orgaId = model.organization_id;
        if (!orgaId) {
            return;
        }
        if (!window.confirm('⚠️ WARNING: Are you sure you want to restore this organization?\n\nThis action should be handled with care. Only proceed if you are certain this organization should be restored.')) {
            return;
        }
        await this.organizationService.restoreOrganization(orgaId);
        $('#orga_modal_new').modal('hide');
        await this.updateOrgas();
    }
    setUserFilter(orga_id) {
        localStorage.setItem('account_user_filter', 'orga:' + orga_id);
    }
    allowSubscriptionManagementOverwrite(modalModel) {
        return modalModel.billwerk_customer_id && modalModel.subscriptions.filter((s) => !s.is_new).length < 2;
    }
    hasUnsavedContractIdChanges(subscription) {
        return !subscription.is_new && subscription.billwerk_contract_id !== subscription.persisted_billwerk_contract_id;
    }
    async syncSubscriptions(e, contractId, organizationId) {
        setLoadingBtn(e);
        if (window.confirm(`The state of all subscriptions belonging to the contract ${contractId} will be synchronized with Frisbii. Your manual changes will be lost. Do you want to continue?`)) {
            try {
                await this.backendService.syncBillwerkSubscriptions(contractId, organizationId);
                $('#orga_modal_new').modal('hide');
                this.openAgain = this.modalModel.organization_id;
                await this.updateOrgas();
            }
            catch (error) {
                console.error('Failed to sync subscriptions with Frisbii', error);
                window.alert('Failed to sync subscriptions with Frisbii');
            }
        }
        resetLoadingBtns();
    }
    async deleteSubscription(e, subscription_id) {
        setLoadingBtn(e);
        if (window.confirm(`The subscription and all associated licenses will be irrevocably deleted. Do you really want to delete the subscription?`)) {
            try {
                await this.organizationService.deleteSubscription(subscription_id, this.modalModel.organization_id);
                $('#orga_modal_new').modal('hide');
                this.openAgain = this.modalModel.organization_id;
                await this.updateOrgas();
            }
            catch (e) {
                console.error('Cannot delete subscription', e);
                window.alert('Oops! Something went wrong. Details: ' + (e.message || ''));
            }
        }
        resetLoadingBtns();
    }
    openNewOrgaModal() {
        this.newOrgaModalModel = createNewOrgaFormViewModel();
        $('#createNewOrgaModal').modal();
    }
    onChangeNewOrgaEmail(model) {
        this.onChangeNewOrgaModel(model);
        const email = model.email.trim().toLowerCase();
        model.emailUserExists = false;
        model.emailDomainClaimed = false;
        if (!isValidEmail(email)) {
            return;
        }
        this.organizationService.getOrganizationEmailConflict(email).then(({ userExists, claimedDomainExists }) => {
            if (this.newOrgaModalModel.email.trim().toLowerCase() === email) {
                this.newOrgaModalModel.emailUserExists = userExists;
                this.newOrgaModalModel.emailDomainClaimed = claimedDomainExists;
            }
        }, (error) => {
            console.error('Cannot check organization email', error);
        });
    }
    async onNewOrgaModalSave(e) {
        this.newOrgaModalModel.gender = +this.newOrgaModalModel.gender || -1;
        setLoadingBtn(e);
        try {
            const orga = await this.organizationService.createOrganization(this.newOrgaModalModel);
            $('#createNewOrgaModal').modal('hide');
            this.openAgain = orga.data.organizationId;
            this.filter = 'orga:' + orga.data.organizationId;
            await this.updateOrgas();
        }
        catch (err) {
            console.error('Cannot create organization', err);
            window.alert('Oops! Something went wrong!');
        }
        finally {
            resetLoadingBtns();
        }
    }
    onChangeNewOrgaModel(model) {
        this.newOrgaModalModel.valid =
            !!model.companyName &&
                !!model.email &&
                model.gender !== null &&
                model.gender !== '' &&
                !!model.firstName &&
                !!model.lastName &&
                !!model.locale;
    }
    onChangePermissionsDeactivated() {
        const deactivations = this.modalModel.permissions_deactivated_object ?? {};
        this.modalModel.permissions_deactivated = Object.keys(deactivations).filter((key) => !!deactivations[key]);
    }
    switchToOrganization(organization_id) {
        this.backendService.switchOrganizationAsSnapaddyAdmin(organization_id).then(() => {
            broadcastOrganizationSwitch('accounts.switchToOrganization', organization_id);
            window.location.href = '/settings/users';
        }, (error) => this.handleSwitchError(error));
    }
    handleSwitchError(error) {
        if (isSupportAccessDeniedError(error)) {
            window.alert('The customer has not granted Support Access. Please ask an organization administrator to grant access.');
            return;
        }
        window.alert('Oops! Something went wrong!');
    }
    /**
     * Helper function for toggling all checkboxes in order to easily release all
     * licenses with just one click
     */
    toggleReleaseCheckboxes(subscriptionId, productId, state) {
        const subscription = this.modalModel.subscriptions.find((s) => s.id === subscriptionId);
        if (!subscription)
            return;
        const products = subscription.products.find((p) => p.id === productId);
        if (!products)
            return;
        for (const userLicense of products.pending_user_licenses) {
            userLicense.release = state;
        }
    }
    /** Helper method for checking if a given date is in the past */
    isExpired(date) {
        return date.getTime() <= Date.now();
    }
    deletionNoticePeriodIsShortened() {
        const noticeUntil = this.modalModel.deletion_notice?.deletion_notice_until;
        const originalNoticeUntil = this.modalModel.original_deletion_notice?.deletion_notice_until;
        return noticeUntil && originalNoticeUntil && noticeUntil.getTime() < originalNoticeUntil.getTime();
    }
    deletionNoticePeriodIsRemoved() {
        return (this.modalModel.original_deletion_notice?.deletion_notice_until &&
            !this.modalModel.deletion_notice?.deletion_notice_until);
    }
    async updateOrgas(page) {
        this.isLoading = true;
        localStorage.setItem('account_orga_page_size', String(this.page_size));
        localStorage.setItem('account_orga_filter', this.filter);
        this.currentPage = page !== undefined ? page : this.currentPage;
        const response = await this.organizationService.getOrganizations(this.currentPage, this.page_size, this.filter, undefined, undefined, this.showDeleted);
        const orgas = [];
        this.max_pages = response.pages;
        this.filtered_orga_count = response.filtered_count;
        this.isLoading = false;
        for (let i = 0; i < response.orgas.length; i++) {
            const orga = {
                ...response.orgas[i],
                articles: [],
            };
            orgas.push(orga);
            for (const subscription of orga.subscriptions ?? []) {
                // A little bit complicated to get the correct valid until :|
                let validUntil;
                if (subscription.organization_subscription_types[0]?.valid_until) {
                    validUntil = new Date(subscription.organization_subscription_types[0].valid_until);
                }
                else {
                    validUntil = new Date(subscription.valid_until);
                }
                orga.articles.push({
                    name: SUBSCRIPTION_TYPES.get(subscription.article_number)?.name ?? 'UNKNOWN',
                    nameShort: SUBSCRIPTION_TYPES.get(subscription.article_number)?.nameShort ?? 'UN',
                    expired: validUntil.getTime() < new Date().getTime(),
                    validUntil,
                    isAppStoreSubscription: !!subscription.app_store_contract_id,
                    isPlayStoreSubscription: !!subscription.play_store_contract_id,
                });
            }
        }
        this.orgas = orgas;
        resetLoadingBtns();
        // Manually apply scope: the `await getOrganizations` continuation runs as a native microtask after the
        // $q-triggered digest has already completed, so the freshly loaded list would otherwise only render on the
        // next digest (e.g. when typing into the search). See revision.controller.ts for the same pattern.
        this.$scope.$apply();
        if (this.openAgain) {
            const orga = this.orgas.find((orga) => orga.organization_id === this.openAgain);
            this.openAgain = undefined;
            if (orga) {
                await this.openModal(orga);
            }
        }
        return this.orgas;
    }
    /**
     * Validate the sanity of assigned licenses.
     * Check that there are at least as many licenses available as assigned
     *
     * @param {*} subscriptions
     */
    proceedWithExceededLicenseLimit(subscriptions) {
        for (const subscription of subscriptions) {
            if (this.unlimitedLicensesArticleNumbers.has(subscription.article_number) ||
                this.concurrentArticleNumbers.has(subscription.article_number)) {
                continue;
            }
            // Check that there are at least as many licenses available as assigned except for concurrent licenses (:= selected article number = 1906)
            const invalidProduct = subscription.products.find((product) => product.used_user_licenses_count > product.max_users);
            if (invalidProduct) {
                return window.confirm(`Warning: The number of licenses of a product is less than the number of assigned licenses.\n\nAffected subscription: ${subscription.article_number}\nAffected product: ${invalidProduct.name}\nNumber of available licenses: ${invalidProduct.max_users}\nLicenses in use: ${invalidProduct.used_user_licenses_count}\n\nDo you want to save anyway?`);
            }
        }
        // No limits exceeded, no confirmation needed, return true to proceed.
        return true;
    }
    async setup() {
        const loadingBtns = document.getElementsByClassName('btn-loading');
        for (let i = 0; i < loadingBtns.length; i++) {
            loadingBtns[i].addEventListener('click', () => loadingBtns[i].classList.toggle('btn-loading-now'));
        }
        const queryParams = this.$location.search();
        if ('organization' in queryParams) {
            this.filter = decodeURIComponent(queryParams.organization);
        }
        else if ('id' in queryParams) {
            this.filter = 'orga:' + decodeURIComponent(queryParams.id);
        }
        else if ('contract-id' in queryParams) {
            this.filter = 'contract-id:' + decodeURIComponent(queryParams['contract-id']);
        }
        else if ('customer-id' in queryParams) {
            this.filter = 'customer-id:' + decodeURIComponent(queryParams['customer-id']);
        }
        else {
            try {
                this.page_size = Number.parseInt(localStorage.getItem('account_orga_page_size') ?? '25') || 25;
            }
            catch (e) {
                this.page_size = 25;
            }
        }
        // skip initial load to not spam the database
        let initializing = true;
        const watchCallback = async (_old, _new) => {
            if (!initializing) {
                await this.updateOrgas(0);
            }
            else {
                this.$timeout(function () {
                    initializing = false;
                });
            }
        };
        this.$scope.$watch(() => this.filter, watchCallback, true);
        this.$scope.$watch(() => this.page_size, watchCallback, true);
        this.$scope.$watch(() => this.showDeleted, watchCallback, true);
        // Initially populate the controller
        const organizations = await this.updateOrgas(0);
        if (queryParams.openModal === 'true' && organizations.length > 0) {
            // Open up first organization
            await this.openModal(organizations[0]);
        }
    }
};
OrganizationController = __decorate([
    Component({
        selector: 'app-organization-controller',
        // no associated template, is embedded static HTML-page in the server assets
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.ILocationService) === "function" ? _a : Object, typeof (_b = typeof OrganizationControllerScope !== "undefined" && OrganizationControllerScope) === "function" ? _b : Object, typeof (_c = typeof ng !== "undefined" && ng.ITimeoutService) === "function" ? _c : Object, Object, Object, Object])
], OrganizationController);
export { OrganizationController };
